var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Router, RedirectToRoute } from "aurelia-router";
import { autoinject } from "aurelia-dependency-injection";
import { UserClaimsService } from "../../services/authentication/user-claims.service";
import { GenesisRouterConstants } from "../../configuration/router.constants";
import * as Enumerable from "linq";
import { TokenClient } from "../../services/authentication/token-client.service";
import { IFramePostMessages } from "../../models/modules/lotteryplatform-client.models";
import { CacheLocation, CacheClient } from "../../services/basics/client-caching.service";
import { NavigationClientService } from "../../services/modules/navigation-client.service";
var ClaimsStep = /** @class */ (function () {
    function ClaimsStep(userClaimsService, userClientService, router, cacheClient, navigationClient) {
        this.userClaimsService = userClaimsService;
        this.userClientService = userClientService;
        this.router = router;
        this.cacheClient = cacheClient;
        this.navigationClient = navigationClient;
        this.isFirstNavigation = true;
    }
    ClaimsStep.prototype.run = function (navigationInstruction, next) {
        var _this = this;
        var requiresAuthAndIsNotAuthenticated = navigationInstruction.config && navigationInstruction.config.auth && !this.userClientService.user;
        var requiresClaimsAndNotHaveClaims = navigationInstruction.config && this.getClaims(navigationInstruction.config) && !this.userClaimsService.hasPermissions(this.getClaims(navigationInstruction.config));
        if (requiresAuthAndIsNotAuthenticated || requiresClaimsAndNotHaveClaims) {
            if (this.router.routes) {
                var route = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return _this.getClaims(x) && _this.userClaimsService.hasPermissions(_this.getClaims(x)); });
                if (route) {
                    return next.cancel(new RedirectToRoute(route.name));
                }
            }
            else {
                return next.cancel(new RedirectToRoute(GenesisRouterConstants.RouteNames.Login));
            }
        }
        if (this.isFirstNavigation) {
            this.isFirstNavigation = false;
            return this.navigateToPervious(next);
        }
        else
            return next();
    };
    ClaimsStep.prototype.navigateToPervious = function (next) {
        var _this = this;
        var canNavigate = window.location.pathname.split("?")[0] == "/client";
        canNavigate = canNavigate && !this.userClientService.isOverlay;
        canNavigate = canNavigate && !this.userClientService.isWidget;
        canNavigate = canNavigate && !this.userClientService.isPreview;
        if (!canNavigate)
            return next();
        var route = JSON.parse(localStorage.getItem("".concat(IFramePostMessages.reloadPage, "-previous-route")));
        if (route) {
            localStorage.removeItem("".concat(IFramePostMessages.reloadPage, "-previous-route"));
            return this.navigate(route, next);
        }
        return new Promise(function (resolve, reject) {
            _this.cacheClient.get(_this.navigationClient.previousRouteKey, CacheLocation.LocalStorage).then(function (cache) {
                _this.navigate(cache, next).then(resolve, reject);
            });
        });
    };
    ClaimsStep.prototype.navigate = function (route, next) {
        if (route) {
            try {
                var params = route.params ? route.params : {};
                params.isAgent = this.userClientService.isAgent();
                return next.cancel(new RedirectToRoute(route.routeName, params, { replace: true }));
            }
            catch (e) {
                console.log("Cannot navigate to route ".concat(route.routeName, " => ").concat(e));
            }
        }
        return next();
    };
    ClaimsStep.prototype.getClaims = function (nav) {
        return nav.claimsRequired ? nav.claimsRequired : (nav.claims ? nav.claims : null);
    };
    ClaimsStep = __decorate([
        autoinject,
        __metadata("design:paramtypes", [UserClaimsService, TokenClient, Router,
            CacheClient, NavigationClientService])
    ], ClaimsStep);
    return ClaimsStep;
}());
export { ClaimsStep };
